import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { storeKeeperRoutes } from './Data'
import AdminNavigation from '../components/navigation/AdminNavigation'

const StoreKeeperRoutes = () => {
    return (
        <Routes>
            <Route element={<AdminNavigation />}>
                {storeKeeperRoutes.map(({ path, element }, index) => (
                    <Route key={index} path={path} element={element} />
                ))}
                <Route path="*" element={<Navigate to="/dashboard/data" />} />
            </Route>
        </Routes>
    )
}

export default StoreKeeperRoutes